import { useEffect, useState } from 'react';

import axios, { type AxiosResponse } from 'axios';

import { useAxiosRequest } from '@admin/hooks';

import { LocationDetailsData, LocationPallet, LocationPalletCustomer, LocationPalletsPage } from './types';

export const useLocationRequest = (id: string) => {
  const [request, setRequest] = useState<Promise<AxiosResponse<LocationDetailsData>> | undefined>();
  useEffect(() => {
    setRequest(axios.get<LocationDetailsData>(`/locations/${encodeURIComponent(id)}.json`));
  }, [id]);
  return useAxiosRequest(request);
};

export const useLocationPalletsRequest = (id: string, page: number) => {
  const [request, setRequest] = useState<Promise<AxiosResponse<LocationPalletsPage>> | undefined>();
  useEffect(() => {
    setRequest(
      axios.get<LocationPalletsPage>(`/locations/${encodeURIComponent(id)}/pallets.json`, {
        params: { page },
      }),
    );
  }, [id, page]);
  return useAxiosRequest(request);
};

export const useCustomersRequest = (accountIDs: number[]) => {
  // Serialize so a new array reference each render does not refetch.
  const accountIDsKey = [...accountIDs].sort((a, b) => a - b).join(',');
  const [request, setRequest] = useState<Promise<AxiosResponse<LocationPalletCustomer[]>> | undefined>();

  useEffect(() => {
    if (!accountIDsKey) {
      setRequest(undefined);
      return;
    }

    setRequest(
      axios.get<LocationPalletCustomer[]>('/customers.json', {
        params: { account_ids: accountIDsKey.split(',').map(Number) },
      }),
    );
  }, [accountIDsKey]);

  return useAxiosRequest(request);
};

export const accountIDsForPallet = (pallet: LocationPallet): Set<number> => {
  const accountIDs = new Set<number>();
  for (const item of pallet.items) {
    accountIDs.add(item.account_id);
  }
  return accountIDs;
};

export const accountIDsForPallets = (pallets: LocationPallet[]): Set<number> => {
  const accountIDs = new Set<number>();
  for (const pallet of pallets) {
    for (const item of pallet.items) {
      accountIDs.add(item.account_id);
    }
  }
  return accountIDs;
};
